import React from 'react';
import { experimentalStyled as styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { CircularProgress } from '@mui/material';
import './ScoreCard.css';
import ScoreBar from './ScoreBar';

interface Props {
  className?: string,
  text: string,
  score: number,
  maxScore: number,
  surveyType: string,
  comparison?: { percentage: number, trend: 'up' | 'down' | 'neutral' } | null | undefined,
  isLoadingComparison?: boolean,
}

const ScoreCard = (props: Props) => {
  const getDisplayText = (): string => {
    if (props.text === 'survey') {
      switch(props.surveyType) {
        case "Employee Burnout":
          return "Burnout Score";
        case "Job Satisfaction Survey":
          return "Job Satisfaction Score";
        case "eNPS":
        case "Employee Net Promoter Score":
          return "eNPS Score";
        default:
          // For custom surveys, always show "Survey Score"
          return "Survey Score";
      }
    }
    return props.text;
  }

  const scoreColor = (): string => {
    let color = "#6DAE43";
    const scoreCurrent = props.score + 1;
    
    // Apply color logic based on survey type
    // For Employee Burnout, BOTH main card AND dimension cards use inverted logic
    switch(props.surveyType) {
      case "Employee Burnout": //Burnout - INVERTIDO: más burnout (score alto) = rojo
        if(scoreCurrent >= 1 && scoreCurrent <= 1.62) return "#6DAE43"; // ≤1.62 = low burnout = green (poco acuerdo con síntomas)
        if(scoreCurrent >= 1.63 && scoreCurrent <= 2.67) return "#FDD835"; // 1.63-2.67 = medium burnout = yellow
        if(scoreCurrent >= 2.68 && scoreCurrent <= 4) return "#FB5523"; // ≥2.68 = high burnout = red/orange (mucho acuerdo con síntomas)
        break;
      case "Employee Engagement": //Engagement - only for main survey card
        if(props.text === 'survey') {
          if(scoreCurrent >= 1 && scoreCurrent <= 2.33) return "#FB5523";
          if(scoreCurrent >= 2.34 && scoreCurrent <= 3.67) return "#FDD835";
          if(scoreCurrent >= 3.67 && scoreCurrent <= 5) return "#6DAE43";
        }
        break;
      case "Job Satisfaction Survey": //Job Satisfaction - only for main survey card
        if(props.text === 'survey') {
          if(scoreCurrent >= 1 && scoreCurrent <= 3) return "#FB5523";
          if(scoreCurrent >= 3.1 && scoreCurrent <= 5.1) return "#FDD835";
          if(scoreCurrent >= 5.1 && scoreCurrent <= 7) return "#6DAE43";
        }
        break;
      default:
        if(props.text === 'survey') {
          // For custom surveys, use blue color (neutral)
          return "#1976D2";
        }
        break;
    }
    return color;
  }

  const Item = styled(Paper)(({ theme }) => ({
      backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#ffff',
      ...theme.typography.body2,
      padding: theme.spacing(2),
      color: theme.palette.text.primary,
      minWidth: '100%',
      height: '128px',
      display: 'flex',
      flexDirection: 'column',
      borderRadius: '8px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
      border: '1px solid #E0E0E0',
  }));
    console.log("props.calssname")
  return (
    <>
      <Item>
      <div className={`${props.className}`} style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <div className='cardName'>{getDisplayText()}</div>
        
        {/* <ScoreBar score={props.score} maxScore={1} /> */}
        <div className={`${scoreColor()} `} style={{
                fontFamily: "'IBM Plex Sans', sans-serif",
                fontSize: window.innerWidth >= 768 && window.innerWidth <= 1200 ? "24px" : "32px",
                color: scoreColor(),
                fontWeight: "600",
              }}>
              {props.text === 'Employee Participation' 
                ? Math.round(props.score + 1)
                : (props.score + 1).toFixed(2)}
            </div>
        
        {/* Show spinner while loading comparison */}
        {props.isLoadingComparison && (
          <div style={{
            display: "flex",
            alignItems: "center",
            gap: "8px"
          }}>
            <CircularProgress size={14} thickness={5} style={{ color: '#666' }} />
            <span style={{
              fontFamily: "'IBM Plex Sans', sans-serif",
              fontSize: "14px",
              color: '#666',
              fontWeight: "400"
            }}>Loading comparison...</span>
          </div>
        )}
        
        {/* Show comparison when loaded and available */}
        {!props.isLoadingComparison && props.comparison && (
          <div style={{
            fontFamily: "'IBM Plex Sans', sans-serif",
            fontSize: window.innerWidth >= 768 && window.innerWidth <= 1200 ? "11px" : "14px",
            color: '#1A237E',
            fontWeight: "400",
            display: "flex",
            alignItems: "center",
            gap: "4px"
          }}>
            <span>{props.comparison.trend === 'up' ? '↑' : props.comparison.trend === 'down' ? '↓' : '='}</span>
            <span>{props.comparison.percentage}% vs last survey</span>
          </div>
        )}
        
        {/* Show "no previous survey" message when loaded but no comparison available (only for template surveys) */}
        {!props.isLoadingComparison && !props.comparison && props.surveyType && 
         props.text !== 'Employee Participation' &&  // Employee Participation never shows comparison messages
         ["Employee Burnout", "Employee Engagement", "Job Satisfaction Survey", "eNPS"].includes(props.surveyType) && (
          <div style={{
            fontFamily: "'IBM Plex Sans', sans-serif",
            fontSize: "13px",
            color: '#999',
            fontWeight: "400",
            fontStyle: "italic"
          }}>
            No previous survey to compare
          </div>
        )}
      </div>
      </Item>
    </>
  )
}

export default ScoreCard;